<div mat-dialog-title>
  <div class="heading">
    <h1 class="heading-item">{{ fileName }}</h1>
    <div class="heading-item right">
      <button mat-icon-button (click)="downloadImage()">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-icon-button (click)="printImage()">
        <mat-icon>print</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="image-container">
  <lib-ngx-image-zoom
    id="img-preview"
    [thumbImage]="imageUrl"
    [fullImage]="imageUrl"
    [enableScrollZoom]="true"
    [zoomMode]="'click'"
  ></lib-ngx-image-zoom>
</div>

<div #actionsContainer mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button (click)="close()">{{ 'Close' | translate }}</button>
</div>

@if (isPrinting) {
  <iframe #printf class="print-frame" [src]="srcUrl"></iframe>
}
